<template>
  <div class="content"></div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment/moment'
import { saveTempData } from '@/api/empSystem/position'

export default {
  name: 'tempData5',
  data() {
    return {}
  },
  methods: {},
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    const contractId =  this.$route.query.contractId

    const empWorkInfo = this.userInfo.empWorkInfo

    const joinedTime = empWorkInfo.joinedTime
    if (!joinedTime) {
      this.$notify({
        type: 'danger',
        message: '入职时间为空，请联系后台人员更新入职信息',
        duration: 3000,
        onClose: () => {
          this.$router.push({
            path: '/myContract',
          })
        },
      })
      return
    }

    const form = {
      tryOutEndTime: moment(joinedTime).add(3, 'month').subtract(1, 'days').format("YYYY年MM月DD日"),
    }

    saveTempData({ contractId: contractId, form: form }).then(() => {
      this.$router.push({
        path: '/contractDetail',
        query: {
          contractId: contractId,
        },
      })
    })
  }
}

</script>

<style scoped></style>
